import React from 'react';

import logo from '../../images/febracis_transparent.png';
import './footer.css';

export default class Footer extends React.Component {
    render() {
        return (
            <footer>
                <div className='flex-vertical footer-wrapper'>
                    <div className='footer-top flex-horizontal'>
                        <a href='https://www.febracis.com.br' target='_blank' rel='noopener noreferrer'>
                            <img src={logo} alt='Febracis EAD'/>
                        </a>
                        <div className='footer-contact'>
                            <div>
                                <i className='fa fa-phone'/>
                                <a href='tel: +5585991896790'> +55 85 99189-6790 </a>
                            </div>
                        </div>
                    </div>
                    <div className='footer-bottom flex-horizontal'>
                        <span>
                            Copyright 2018 Febracis Coaching
                        </span>
                        <div className='footer-social-line'>
                            <a href='https://www.facebook.com/febraciscoaching/' target='_blank' rel='noopener noreferrer'>
                                <i className='fa fa-facebook-square'/>
                            </a>
                            <a href='https://www.youtube.com/channel/UCrXwk3lBrIw36KOsxUcon0g' target='_blank' rel='noopener noreferrer'>
                                <i className='fa fa-youtube-play'/>
                            </a>
                            <a href='https://www.instagram.com/febraciscoaching/' target='_blank' rel='noopener noreferrer'>
                                <i className='fa fa-instagram'/>
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/footer/footer.js